
export class Sectorization {
  doc:number;
  minangle:number;
  maxangle:number;
  minaltitude:number;
  maxaltitude:number;
  id:string;
  isselected : boolean = false;
  istodelete : boolean = false;
  ishalf?: boolean;
  isminanglenegative?: boolean;
  ismaxanglenegative?: boolean;
  

  public static equalsSectorization(sectorization: Sectorization, otherSectorization: Sectorization) {
    return (
      sectorization.doc == otherSectorization.doc &&
      sectorization.maxaltitude == otherSectorization.maxaltitude &&
      sectorization.maxangle == otherSectorization.maxangle &&
      sectorization.minaltitude == otherSectorization.minaltitude &&
      sectorization.minangle == otherSectorization.minangle
    );
  }
}
